export default {
  hero: {
    "at-my-place": "Chez moi",
    professional: "Professionnel",
    "solar-storage": "Solaire + Stockage",
    headline: {
      before: "Obtenez le ",
      highlight: "meilleur prix",
      after: " pour votre autonomie",
    },
    description:
      "Choisissez l'offre la moins chère et la plus avantageuse pour votre investissement solaire parmi les installateurs locaux de systèmes solaires et de stockage.",
    "get-best-price": "Obtenir le meilleur prix",
    "calculate-savings": "Calculer mes économies",
    features: {
      noSubcontracting: "Pas de sous-traitance",
      noCalling: "Pas d'appels",
      noStringsAttached: "Sans condition",
    },
  },
  "how-it-works": {
    tagline: "1,2,3 partez",
    title: "Comment fonctionne la première plateforme d'enchères en ligne ?",
    subtitle:
      "Recevez et comparez plusieurs devis détaillés tout en restant anonyme.",
    stepLabel: "Étape",
    "step1-title":
      "Obtenez au moins 4 devis compétitifs auprès d'installateurs locaux",
    "step2-title": "Choisissez votre prix !",
    "step2-bullet1": "Évitez les arnaques",
    "step2-bullet2": "Visites techniques obligatoires",
    "step3-title": "Commencer la demande de permis gratuit",
    "step3-bullet1": "Prenez une longueur d'avance",
    "step3-bullet2": "Le plus rapide",
    "step4-title": "Contrôle qualité",
  },
  "vetted-local-artisans": {
    tagline: "Partout dans le pays, près de chez vous",
    title: "Artisans locaux sélectionnés",
    description:
      "Uniquement des installateurs certifiés RGE, vérifiés chaque mois.",
    "directory-button": "Consultez le répertoire",
    "start-with-installer": "Commencer avec cet installateur",
  },
  videos: {
    tagline: "Selon leurs propres mots",
    title: "Le meilleur dans son domaine",
    description:
      "Tous les installateurs présents sur notre plateforme sont certifiés RGE, assurés et travaillent activement dans votre région.",
    "no-video": "Aucune vidéo",
    pause: "Pause",
    play: "Lecture",
    "aria-previous-video": "Vidéo précédente",
    "aria-next-video": "Vidéo suivante",
    "aria-expand": "Plein écran",
  },
  "our-results": {
    tagline: "Nos résultats",
    title:
      "Nous sommes le numéro 1 des orchestrateurs de chantiers solaires dans tout le pays",
    "map-tooltip": "{count} Chantiers dans {name}",
    "stat-1-value": "4 propositions",
    "stat-1-description": "Entreprises par appel d'offres, moyenne",
    "stat-2-value": "100 +",
    "stat-2-description":
      "Installateurs photovoltaïques de proximité, tous certifiés RGE",
    "stat-3-value": "40 %",
    "stat-3-description": "Réduction sur montant du devis, moyenne",
    "stat-4-value": "3 000 +",
    "stat-4-description":
      "Chantiers solaires rendus possibles sur notre plateforme communautaire",
  },
  "customer-testimonials": {
    tagline: "Clients",
    title: "Écoutez ce que nos clients ont à dire",
    subtitle: "De la citation au kWh: leurs histoires",
    "system-power": "Puissance du système",
    "battery-power": "Puissance de la batterie",
    autonomy: "Autonomie",
    roi: "RSI",
    "per-year": "par an",
  },
  solutions: {
    tagline: "Solutions énergétiques",
    title: "Ce que vous pouvez faire avec votre production",
    subtitle: "Nous soutenons tout cela",
    "read-more": "En savoir plus",
    items: {
      "off-grid": {
        title: "Solaire hors réseau",
        description:
          "Indépendance énergétique totale. Produisez, stockez et utilisez votre propre énergie sans dépendre du réseau électrique.",
      },
      "virtual-battery": {
        title: "Batterie virtuelle",
        description:
          "Stockez votre surplus sur le réseau et récupérez-le lorsque vous en avez besoin, sans avoir besoin d'une batterie physique.",
      },
      "sell-to-grid": {
        title: "Revente au réseau",
        description:
          "Vous produisez plus que vous ne consommez ? Vendez votre surplus à EDF OA et tirez profit de votre toiture.",
      },
      "variable-rates": {
        title: "Vente à taux variables",
        description:
          "Optimisez vos revenus en vendant votre surplus aux tarifs du marché en temps réel plutôt qu'à des tarifs fixes.",
      },
      "community-solar": {
        title: "Solaire communautaire",
        description:
          "Partagez une installation solaire avec vos voisins. Des coûts réduits, la même énergie propre.",
      },
      "total-resale": {
        title: "Revente totale",
        description:
          "Vendez 100 % de votre production au réseau et transformez votre toit en une source de revenus pure.",
      },
    },
  },
  "image-hotspots": {
    tagline: "Tout-en-un",
    title: "Votre maison, entièrement équipée",
    description:
      "Panneaux solaires, batteries, chargeurs EV : une seule plateforme pour tout planifier.",
    "read-more": "Lire la suite",
    products: {
      "plug-play": {
        title: "Étude indépendante",
        description:
          "Produisez de l'énergie solaire en quelques minutes : branchement simple, sans installation ni permis.",
      },
      roof: {
        title: "Installation de toiture",
        description:
          "Obtenez une étude complète de votre autonomie, économies et rentabilité, adaptée à votre toiture.",
      },
      battery: {
        title: "Installez une batterie",
        description:
          "Stockez votre énergie solaire et réduisez votre dépendance au réseau.",
      },
      "car-charger": {
        title: "Installer un chargeur de voiture",
        description:
          "Rechargez votre véhicule électrique à l'énergie solaire et réduisez vos coûts.",
      },
      heater: {
        title: "Installer un chauffage",
        description:
          "Passez au chauffage électrique solaire et réduisez votre facture.",
      },
    },
  },
  "how-to-achieve": {
    tagline: "Technologie",
    title: "Comment atteindre l'autonomie ?",
    description:
      "Il y a une urgence climatique. Nous devons tous passer rapidement à l'énergie propre.",
    "read-more": "Lire la suite",
    steps: {
      "step-1": {
        title: "Choisissez votre système solaire",
        description:
          "Obtenez une étude de votre pourcentage d'autonomie électrique et de vos économies potentielles.",
      },
      "step-2": {
        title: "Choisissez votre devis personnalisé",
        description:
          "Recevez plusieurs offres détaillées d'installateurs photovoltaïques certifiés.",
      },
      "step-3": {
        title: "Valider la faisabilité du chantier",
        description:
          "Rencontrez le technicien chez vous afin d'évaluer la faisabilité technique et de confirmer les spécifications de votre installation.",
      },
      "step-4": {
        title: "Choisissez votre devis",
        description:
          "Comparez les propositions reçues, sélectionnez l'offre la plus adaptée à vos besoins et signez votre devis en ligne.",
      },
      "step-5": {
        title: "Approbations",
        description:
          "Nous prenons en charge toutes les démarches administratives : déclaration en mairie, validation CONSUEL et raccordement au réseau Enedis.",
      },
      "step-6": {
        title: "Installation et mise en service",
        description:
          "Votre installateur certifié pose vos panneaux solaires et met en service votre système. Vous commencez à produire votre propre électricité.",
      },
    },
  },
  "lead-flow": {
    address: {
      title: "Où se situe votre gisement solaire ?",
      subtitle: "Entrez votre addresse ci-dessous",
      buildingNotFoundDescription:
        "Votre batîment n'est pas celle indiqué par l'épingle ? Faites-la glisser sur le point exact.",
      continueButton: "Suivant",
    },
    "electricity-bill": {
      title: "Votre facture d'électricité",
      description:
        "Cet espace est dédié à l’ajout de votre facture d’électricité récente. Elle nous permet de vérifier votre identité, d'établir votre type de contrat d'électricité, et de créer une prévision de votre nouvelle facture d'électricité en passant au solaire. Ces données sont personnelles et protégées ; elles ne sont utilisées sur notre plateforme que dans le cadre de votre chantier solaire.",
      terms: "Pourquoi nous vous demandons votre facture d'électricité ?",
      tooltip: {
        title: "Veillez à ce que ces informations soient présentes :",
        requiredFields: {
          price: "Prix du kWh",
          size: "Puissance (kVa)",
          type: "Type de contrat (base/heure pleines heures creuses)",
          pdl: "Numéro PDL",
        },
      },
    },
    "enedis-mandate": {
      linky: {
        title: "Êtes-vous équipé d'un compteur Linky ?",
        description:
          "Si vous possédez un compteur Linky, nous pouvons procéder à l’analyse horaire de votre historique de consommation en kWh. Cela nous permettra de calculer votre potentiel d’autoconsommation électrique heure par heure, et vous réaliser ainsi une étude techniquement précise.",
        "no-linky": {
          title:
            "Sans Linky nous ne sommes pas en mesure de vous réaliser une étude technico-financière à partir de mesures horaires. Vous pouvez demander le remplacement gratuit de votre compteur actuel par un compteur Linky en",
          link: "",
        },
      },
      title: "Autorisation Linky",
      subtitle:
        "Afin de pouvoir étudier votre historique de consommation d'électricité depuis votre compteur Linky, votre accord est nécessaire pour accéder vos données personnelles, en tant qu’entité référencée auprès d’Enedis. Vos données sont protégées et ne seront utilisées et conservées qu'à cette fin.",
      form: {
        required: {
          enedisHistoricMeasurementsAccessGranted:
            "L'historique des mesures est requis.",
          enedisHistoricDailyConsumptionDataAccessGranted:
            "L'historique des relevés est requis.",
          enedisHistoricPowerDataAccessGranted:
            "L'historique de la puissance est requis.",
          enedisHistoricConsumptionLoadCurveDataAccessGranted:
            "L'historique de courbe est requis.",
          enedisContractAccessGranted:
            "Les données techniques et contractuelles sont requises.",
        },
      },
    },
    informations: {
      title: "Dernière étape",
      subtitle: "Pour obtenir votre étude gratuite.",
      firstname: "Prénom",
      lastname: "Nom",
      "company-name": "Raison sociale",
      "company-siret": "SIRET",
      phone: "Téléphone",
      password: "Mot de passe",
      "confirm-password": "Confirmez votre mot de passe",
      "see-stories": "Voir les autres histoires",
    },
    type: {
      title: "Vous êtes {type}",
      RESIDENTIAL: "Un particulier",
      BUSINESS: "Une entreprise",
    },
    "project-type": {
      title: "Quel sera votre chantier solaire sur-mesure ?",
      dismiss: "Fermer",
      next: "Suivant",
      carport: "Carport",
      pergola: "Pergola",
      "ground-mount": "Au sol",
      tiles: "Sur toiture",
      "flat-roof": "Toiture terrasse",
      "solar-tiles": "Tuiles solaires",
    },
    "registration-success": {
      title: "Un email de confirmation vous a été envoyé",
      subtitle:
        "Votre étude est en cours de préparation ! Pour suivre son avancement consultez votre profil",
      question:
        "Avous-vous des questions ? Ou souhaitez-vous parler de votre chantier avec une personne de notre équipe ?",
      calendly: "Prennez rendez-vous avec l'un de nos collaborateurs !",
    },
    location: "Emplacement",
    profile: "Profil",
    projectType: "Type de chantier",
    "electricity-bill-document": "Facture électrique",
    consumptionData: "Donnée de conso",
  },
  "how-to": {
    title: "Comment accéder à l'autonomie solaire ?",
    "steps-title": "Les étapes.",
    "description-2":
      "Nous développons une plateforme communautaire clé-en-main de mise en lien entre tout porteur de chantier solaire et les professionnels du photovoltaïque et du stockage.",
    "description-1":
      "La flambée des prix est hors de contrôle. Notre objectif est de faciliter, sécuriser puis démocratiser à grande échelle toutes les étapes de l'installation photovoltaïque.",
    description:
      "Nous visons à rationaliser, sécuriser et démocratiser les installations photovoltaïques à grande échelle, à travers quelques étapes simples que nous réalisons, avec vous.",
    "check-full-guide": "Découvrir le guide en entier",
    steps: {
      analyze: {
        title: "Analyser",
        description:
          "Nous estimons votre autonomie et vos économies avec une étude de haut niveau, puis nous vous envoyons une présentation",
        duration: "1 semaine",
      },
      "compare-hire": {
        title: "Comparer et embaucher",
        description:
          "Recevez des devis détaillés d'installateurs RGE à proximité.",
        duration: "1 semaine",
      },
      regulations: {
        title: "Réglementation",
        description:
          "Les démarches d'urbanisme et de raccordement sont gérées avec vous.",
        duration: "1 mois",
      },
      installation: {
        title: "Installation",
        description: "Votre système est installé, mis en service et connecté.",
        duration: "1 semaine",
      },
    },
  },

  "why-us": {
    title: "Pourquoi choisir projetsolaire ?",
    "description-1":
      "Nous encadrons la réalisation de votre installation photovoltaïque par un maitre d'œuvre RGE : transparence des offres des poseurs, sans engagement, à votre rythme.",
    "description-2": "Le service est gratuit pour les particuliers.",
    features: {
      //unused
      model: {
        title: "Étude technico-financière à distance",
        description:
          "Notre étude photovoltaïque détermine le nombre optimal de panneaux solaires chez vous, ainsi que leurs rendements, afin de définir votre cahier des charges indépendamment des installateurs photovoltaïques.",
      },
      installers: {
        title: "Mise en service avec les artisans photovoltaïques",
        description:
          "Notre appel d’offres en ligne vous permet de recevoir plusieurs devis détaillés et sur-mesure d’installateurs de proximité, tout en restant anonyme.",
      },
      administration: {
        title: "Démarches dématérialisées",
        description:
          "Nos services numériques incluent toutes les démarches administratives : autorisations d’urbanisme, demandes de raccordement, sécurité électrique, commercialisation du surplus, bureaux de contrôle.",
      },
      support: {
        title: "Accompagnement clé-en-main",
        description:
          "Besoin de financement par prêt bancaire ? Questions sur les assurances et garanties ? Nous prenons le temps avec les acteurs votre chantier solaire.  Nous sécurisons les travaux du cahier de charges jusqu’au recyclage des panneaux.",
      },
    },
    "start-with-this-installer": "Commencer avec cet installateur",
  },
  stats: {
    "our-track-record": "Nos résultats",
    title: "Première plateforme en ligne d'appels d'offres du solaire",
    subtitle: "Par des professionnels du solaire, pour tous.",
    description:
      "Connecter les individus passant au solaire avec les experts en installation, rendant le passage au solaire en France plus simple que jamais.",
    "about-us-button": "A propos de nous",
    "stats-value": {
      "aided-solar-projects": {
        title:
          "Chantiers solaires rendus possibles sur notre plateforme communautaire",
        value: "10 000 +",
      },
      "installers-in-network": {
        title: "Installateurs photovoltaïques de proximité, tous certifiés RGE",
        value: "1200 +",
      },
      "3-quotes-guarantee": {
        title: "Entreprises par appel d'offres, moyenne",
        value: "4 propositions",
      },
      "average-time-install": {
        title: "Durée moyenne d'installation",
        value: "3 mois",
      },
      "cost-reduction": {
        title: "Réduction sur montant du devis, moyenne",
        value: "40 %",
      },
    },
  },
  "logo-cloud": {
    title: "Découvrez les témoignages de nos clients",
    description: "De devis à kWh: leurs histoires",
    readNow: "Lire",
    moreCaseStudies: "Plus d'études de cas",
    testimonials: {
      john: {
        testimonial: "Leur soutien est inégalé. Déjà conseillé à 8 amis !",
      },
      mathilde: {
        testimonial:
          "Quand on a eu des dégâts dans notre maison, projetsolaire a toujours été là.",
      },
      michel: {
        testimonial:
          "Le seul chantier parmi nos travaux en cours qui s'est bien passé. Le prix du panneau solaire est plus que raisonnable.",
      },
    },
  },
  stories: {
    title: "Des centaines d'entreprises locales",
    description:
      "Ils soumettent des propositions, vous comparez et choisissez la meilleure. Vous gagnez.",
    button: "Découvrez leurs témoignages",
  },
  community: {
    title: "Rejoignez notre mouvement citoyen",
    description:
      "Tous les jours nous aidons des familles à découvrir leurs potentiels solaires. Nous avons déjà aidé des centaines de foyers à accéder au solaire dans toute la France. Commencez votre passage à l’autonomie solaire aujourd’hui et rejoignez le mouvement national.",
  },
  newsletter: {
    title: "Abonnez-vous à notre newsletter",
    subtitle:
      "Abonnez-vous à notre newsletter pour rester informé des actualités et des mises à jour.",
    placeholder: "Adresse e-mail",
    button: "S'abonner",
  },
  mission: {
    tagline: "Pourquoi nous choisir ?",
    comparisonHeading: "Tous les chemins solaires ne se valent pas",
    comparisonDescription:
      "Comparez vos options. Notre plateforme est gratuite pour les propriétaires et vous offre plus pour moins cher.",
    title: "Notre garantie de sécurité",
    subtitle: "L'autonomie solaire à portée de main",
    paragraph1:
      "Il y a plein de façons de passer au solaire. Voici quelques points qui sont différents avec ProjetSolaire.",
    cardTitle: "Artisans Locaux Vérifiés",
    cardDescription:
      "Uniquement des installateurs certifiés RGE, contrôlés mensuellement.",
    card1Title: "Tarification Transparente",
    card1Description: "Plusieurs tarifs compétitifs; à vous de choisir.",
    card2Title: "Aide Complète",
    card2Description: "Du conseil à la paperasse aux commissions.",
    buttons: {
      regulatory: "Réglementaire",
      articles: "Articles",
      learn: "Apprendre",
      estimator: "Estimateur",
    },
    paragraph2: "Réduire le prix du solaire",
    paragraph3: "Mettre fin à l'éco-délinquance",
    paragraph4: "Accélérer la transition énergétique",
    paragraph5:
      "Projetsolaire.com c'est donc le chantier solaire d'une famille, d'une PME familiale, d'une commune… c'est son chantier solaire, c'est leur chantier solaire. C'est enfin votre chantier solaire aussi.",
    comparison: {
      title: "Plusieurs manières de le faire.",
      subtitle:
        "Voici comment elles diffèrent les unes des autres. Ce service est gratuit pour les particuliers.",
      freeService: "Le service est gratuit pour les particuliers.",
      columns: {
        doItAlone: {
          title: "Par vous même",
          features: {
            0: "Fourchette de prix (2 €/W - 3 €/W)",
            1: "Aucune commission de vente",
            2: "Aucun sous-contrat",
            3: "Puissance de l'équipement (375 W - 400 W)",
            4: "Etude indépendante",
          },
        },
        projetsolaire: {
          title: "Projetsolaire",
          features: {
            0: "Fourchette de prix (1 €/W - 2 €/W)",
            1: "Aucune commission de vente",
            2: "Appel d'offres concurrentiel",
            3: "Aucun sous-contrat",
            4: "Garantie dix ans",
            5: "Puissance de l'équipement (375 W - 500 W)",
            6: "Etude indépendante",
            7: "Suivi administratif",
            8: "Contrôle tiers",
          },
        },
        largeGroups: {
          title: "Grands Groupes",
          features: {
            0: "Fourchette de prix (3 €/W - 5+ €/W)",
            1: "Garantie dix ans",
            2: "Puissance de l'équipement (330 W - 375 W)",
            3: "Suivi administratif",
          },
        },
      },
    },
  },
  cta: {
    title: {
      line1: "Nous coordinons les",
      line2: "parties prenantes de votre chantier",
      line3: "solaire",
    },
    subtitle:
      "Construisez, gérez, et échelonnez votre business solaire avec confiance.",
    buttonGetStarted: "Commencer",
    buttonBookDemo: "Demander une Démo",
    benefit: {
      benefit1: "Visite technique obligatoire",
      benefit2: "Autorisation de l'urbanisme",
      benefit3: "Contrôle sécurité électrique",
      benefit4: "Mise en service avec Enedis",
      benefit5: "Coffre-fort numérique",
      benefit6: "Suivi en temps réel de production",
    },
    button: "Explorer",
  },
  "learn-centre-cta": {
    title: "Tout savoir sur",
    description: "Consultez nos articles pour devenir un pro du solaire.",
  },
  "action-buttons": {
    "discover-potential": {
      title: "Découvrez votre potentiel solaire",
      description:
        "Analyse rapide de vos économies élec à partir de votre compteur Linky. Nous calculons la valeur énergétique, économique et environnementale de votre gisement solaire.",
    },
    "best-price": {
      title: "Obtenez le meilleur prix",
      description:
        "Choisissez votre prix ! Faites jouer la concurrence, les entreprises veulent gagner votre chantier. Laissez-nous obtenir plusieurs devis complets, détaillés et sur-mesure.",
    },
  },
  faq: {
    tagline: "Il reste quelque chose ?",
    title: "Vos questions sur l'énergie solaire",
    "different-question": "Vous avez une autre question ?",
    "get-call-back": "Recevoir un appel",
    "read-more-blog": "Pour en savoir plus",
    items: {
      cost: {
        question: "Combien cela coûte-t-il ?",
        answer:
          "Grâce à notre plateforme, comptez entre 1 €/W et 2 €/W, soit nettement moins que les grands installateurs nationaux qui facturent entre 3 € et 5 €+/W. Pour une installation type de 3 kWc, cela représente environ 3 000 € à 6 000 € avant toute subvention gouvernementale.",
      },
      "why-free": {
        question: "Pourquoi ce service est-il gratuit ?",
        answer:
          "Nous prélevons une petite commission auprès de l'installateur lorsqu'un chantier est terminé. Vous ne nous payez jamais rien. Ce modèle signifie que nous ne réussissons que lorsque vous obtenez une bonne installation — nos motivations sont alignées sur les vôtres.",
      },
      profitable: {
        question: "En quoi l'énergie solaire est-elle rentable ?",
        answer:
          "Une installation de taille adéquate est généralement rentabilisée en 7 à 10 ans, puis produit de l'électricité gratuite pendant plus de 20 ans. Vous réalisez immédiatement des économies sur votre facture et tout excédent peut être revendu à EDF OA pour générer des revenus supplémentaires.",
      },
      problem: {
        question: "Que se passe-t-il en cas de problème ?",
        answer:
          "Tous les installateurs présents sur notre plateforme sont assurés et offrent une garantie décennale sur leur travail. Vos panneaux et votre onduleur sont couverts par une garantie constructeur de 20 à 25 ans. Nous proposons également un contrôle qualité par un tiers et un suivi administratif après l'installation.",
      },
      "get-started": {
        question: "Comment commencer ?",
        answer:
          "Entrez votre adresse, répondez à quelques questions sur votre consommation d'énergie et recevez une étude solaire gratuite en quelques minutes. Vous pourrez ensuite consulter la liste des installateurs disponibles dans votre région et demander des devis, le tout gratuitement.",
      },
    },
  },
}
